<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.content_share_create"
    sb-button-primary
    type="button"
    color="green"
    icon="plus"
    sbTooltip="{{ 'lang.globals.create' | translate }}"
    [iconButton]="true"
    [loading]="loading()"
    (click)="createNewContentShare(); toggleSideBar();">
  </button>
  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
  <a
    *ngPermissions="permissionService.Permission.ss_nm_reporting"
    [sbRouterLink]="util.RoutingID.networkAllocation" target="_blank" [queryParams]="{planning: planning?.id}"
    sb-button-primary
    icon="bookings"
    [color]="'blue'"
    class="!tw-text-white"
  >{{ 'nav.network.networkAllocation' | translate }}
  </a>
</ng-container>

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="1200">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <h4 [innerHTML]="selectedContentShare?.name ?? 'lang.globals.createNewContentShare' | translate">
  </h4>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-content-share-edit [contentShare]="selectedContentShare" [planning]=" planning"
                              (contentShareChanged)="updateContentShares($event)"></sb-page-content-share-edit>
</ng-template>

<ng-template #sidePanelFooter>
  <div class="tw-flex tw-justify-between">
    <button type="button"
            class="btn btn-default">{{ 'lang.globals.cancel' | translate }}
    </button>
    <button type="submit"
            class="btn btn-success">{{ 'lang.globals.submit' | translate }}
    </button>
  </div>
</ng-template>

<!------------------------------

  Table Wrapper

------------------------------->

@let isExpanded = checkExpansion();

<sb-table-wrapper-new
  headline="{{('nav.campaigns.contentShare' | translate) }}"
  [itemsData]="contentShares"
  [isMultiSelectEnabled]="submissions.size>0 || !!planning"
  (paginationChange)="requestDebounced($event)" [loading]="loading()" [itemName]="'contentShare'"
  [iterateTableRows]="false">

  <!------------------------------

     Filter

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

      <sb-filter-section *ngPermissions="permissionService.Permission.planning_list" title="{{'lang.planningsList.headline' | translate}}"
                         icon="plannings">
        <sb-filter-dto-list-select filterID="planning" [isSingleSelect]="true" [endpoint]="api.ds_cm_Planning_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <div
        #filterPanelTimeRange
        class="tw-flex tw-flex-row tw-mx-3 tw-font-semibold tw-items-center tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-group tw-w-fit "
        [ngClass]="{'tw-cursor-pointer': !isExpanded}"
        (click)="!isExpanded?openFilterPanel(filterPanelTimeRange):scrollToFilterPanelElement(filterPanelTimeRange)">
        <sb-icon class="" [ngClass]="{'tw-ml-2.5': !isExpanded}" icon="calendar"></sb-icon>
        <div class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-text-lg tw-flex-1"
             [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.timeRange' | translate }}
        </div>
      </div>

      @if (isExpanded) {
        <div>

          <div class="form-group tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-mx-3"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-auto': isExpanded,
    }">
            <sb-local-date-time-input (modelChange)="localDateTimeInputFrom($event)" [kind]="'RANGE_START'"
                                      [ngModel]="from" [seconds]="false"
                                      [title]="translate.instant('lang.globals.startTime')" class="tw-w-full">
            </sb-local-date-time-input>
          </div>
          <div class="form-group tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-mx-3"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-auto': isExpanded,
    }">
            <sb-local-date-time-input (modelChange)="localDateTimeInputTill($event)" [ngModel]="till" [kind]="'RANGE_END'"
                                      [minDate]="from"
                                      [seconds]="false" [title]="translate.instant('lang.globals.dueTime')"
                                      class="tw-w-full"></sb-local-date-time-input>
          </div>
        </div>
      }

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>

      @if (!submissionID && permissionService.hasPermission(permissionService.Permission.content_share_edit)) {
        <th></th>
      }
      @if (planning && !submissionID) {
        <th>
          <sb-comp-table-multi-select-button
            [selectionState]="selectionState"
            (action)="selectAction($event)">
          </sb-comp-table-multi-select-button>
        </th>
      }
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.level' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.type' | translate }}
      </th>
      <th>
        {{ 'lang.globals.validity' | translate }}
      </th>
      <th>
        {{ 'lang.globals.filter' | translate }}
      </th>
      <th>
        {{ 'lang.globals.quotas' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      @if (!submissionID) {
        <th class="tr sticky-col last-col">
          {{ 'lang.globals.action' | translate }}
        </th>
      }
    </tr>
  </ng-template>
  <!------------------------------

      SelectionMode

------------------------------->
  <ng-template #tSelectionMode>
    @if (!submissionID) {
      <sb-action-bar>
        <!-- projected info -->
        <div info>
          {{ submissions.size }} {{ 'lang.globals.selected' | translate }}
        </div>

        <!-- deselect button -->
        <button
          deselect
          type="button"
          sb-button-secondary
          [color]="'blue'"
          class="tw-text-nowrap"
          [disabled]="submissions.size <= 0"
          (click)="selectAction('deselectAll')">
          {{ 'lang.multiSelect.deselectAll'|translate }}
        </button>

        <!-- actions -->
        <button
          *ngIf="permissionService.hasPermission(permissionService.Permission.planning_submit) && !submissionID"
          actions
          type="button"
          sb-button-primary
          [color]="'purple'"
          icon="planningSubmit"
          (click)="submitPartialPlanningModal()"
          [disabled]="submissions.size <= 0 || showSideBar">
          {{ 'lang.globals.submitPartialPlanning'| translate }}
        </button>
        <button
          *ngIf="permissionService.hasPermission(permissionService.Permission.planning_submit) && !submissionID"
          actions
          type="button"
          sb-button-primary
          [color]="'blue'"
          icon="planningSubmit"
          (click)="submitPlanningDateModal()"
          [disabled]="">
          {{ 'lang.globals.submitPlanningDate'|translate }}
        </button>
        <button
          *ngIf="permissionService.hasPermission(permissionService.Permission.planning_submit) && !submissionID"
          actions
          type="button"
          sb-button-primary
          [color]="'yellow'"
          icon="planningSubmit"
          (click)="submitPlanningModal()"
          [disabled]="">
          {{ 'lang.globals.submitPlanning' | translate }}
        </button>

      </sb-action-bar>
    } @else {
      <div class="tw-font-semibold">{{ ('lang.globals.planningName' | translate: { name: planning?.name }) }}</div>
      <div class="vertical-spacer tw-mx-3"></div>
      <div class="tw-flex tw-gap-3">
        @if (permissionService.hasPermission(permissionService.Permission.planning_accept)) {

          <button (click)="acceptPlanning(planning)"
                  sb-button-primary
                  color="green"
                  type="button"
                  icon="checked"
          >
            {{ 'lang.globals.accept' | translate }}
          </button>
        }
        @if (permissionService.hasPermission(permissionService.Permission.planning_submit)) {
          <button (click)="rejectPlanning(planning)"
                  sb-button-primary
                  color="red"
                  type="button"
                  icon="cancel">
            {{ 'lang.globals.reject' | translate }}
          </button>
        }

      </div>

    }
  </ng-template>


  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody>

    <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: contentShares, level: 0 }">
    </ng-container>

  </ng-template>

</sb-table-wrapper-new>

<ng-template #recursiveListTmpl let-list="list" let-level="level">
  @for (item of list; track item.id; let index = $index; let last = $last) {
    <tr *ngIf="isDragging" [attr.data-share]="item?.precondition?.id" (drop)="onDrop($event, index)"
        (dragover)="onDragOver($event)">


      <td colspan="100" class="tw-text-center">
        {{ 'lang.globals.position' | translate }} {{ item.name }}
      </td>
    </tr>
    <tr [draggable]="!submissionID" [ngClass]="{'*:tw-opacity-50': planning && !item.planning}"
        [attr.data-share]="item?.id" (drop)="onDrop($event)" (dragstart)="onDragStart($event)"
        (dragend)="onDragEnd($event)" (dragover)="onDragOver($event)" (dragenter)="isDragging = true"
        [style.background]="isNumberEven(level) ? null : 'rgba(239, 239, 239, .5)'">
      @if (!submissionID && permissionService.hasPermission(permissionService.Permission.content_share_edit)) {
        <td>
          <div
            class="btn btn-hover-primary mr-3"
            (mousedown)="onmousedown($event)" (mouseleave)="onmouseup($event)">
            <sb-icon icon="drag"></sb-icon>
          </div>
        </td>
      }
      @if (planning && !submissionID) {
        <td>
          @let isContentShareSelected = submissions.has(item?.id) ?? false;
          <sb-comp-table-select-button [isSelected]="isContentShareSelected" [disabled]="!item.planning"
                                       (action)="selectForSubmission(item)"></sb-comp-table-select-button>
        </td>
      }
      <td>
        @if (item.preconditionOf && item.preconditionOf?.length > 0) {
          @if (showChildren.has(item?.id)) {
            <sb-icon
              [style.margin-left.px]="level"
              [icon]="'minus'" class="cursor-pointer"
              (click)="toggleShowChildren(item)"></sb-icon>
          } @else {

            <sb-icon
              [style.margin-left.px]="level"
              [icon]="'plus'" class="cursor-pointer"
              (click)="toggleShowChildren(item)"></sb-icon>
          }
        } @else {
          <sb-icon [style.margin-left.px]="level"
                   [icon]="'plus'" style="opacity: 0;"></sb-icon>
        }
        &nbsp;
        {{ item.id }}
      </td>
      <td>
        {{ item.level }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <div firstLine>
            <span [innerHTML]="item.name | truncate:30"></span>
          </div>
          <div secondLine>
            <small secondLine [innerHTML]="item.description| truncate:50"></small>
          </div>
          <div thirdLine>
            <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [resolveInComponent]="true"
                     [dtoType]="tagService.TaggableDTO.ContentShare" [dtoId]="item.id">
            </sb-tags>
          </div>
        </sb-comp-name-wrapper>
      </td>

      <td>
        {{ item.quotaDistributionBasis ? ('lang.globals.' + item.quotaDistributionBasis.toLowerCase() | translate) : '-' }}
      </td>
      <td>
        <sb-comp-validity-range-display [from]="item.validFrom" [till]="item.validTill"></sb-comp-validity-range-display>
      </td>
      <td>
        <sb-comp-filter-overview hideClass="d-xxl" [timeCull]="item?.timeCull" [geoCull]="item?.geoCull"
                                 [stateSpaceCull]="item?.stateSpaceCull" [playerCull]="item?.playerCull">
        </sb-comp-filter-overview>
      </td>
      <td>
        <div class="tw-flex tw-justify-center tw-min-w-[500px]">
          @if (!item?.quotas || item?.quotas?.length === 0) {
            <i>{{ 'lang.globals.noQuotas' | translate }}</i>
          } @else {
            <div class="tw-flex tw-w-full tw-gap-2">
              <sb-comp-single-quota *ngFor="let quota of item.quotas" [quota]="quota" [width]="quota.share"></sb-comp-single-quota>
            </div>
          }
        </div>
      </td>
      <td class="d-xxl-table-cell d-none">
        <sb-comp-display-modified [data]="item"></sb-comp-display-modified>
      </td>
      @if (!submissionID) {
        <td class="tr sticky-col last-col !tw-opacity-100">
          <sb-split-button
            [splitButtonItems]="item.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(item, $event)"
          ></sb-split-button>
        </td>
      }
    </tr>
    @if (item?.preconditionOf?.length > 0 && showChildren.has(item?.id)) {
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ list: item.preconditionOf, level: level + 25 }">
      </ng-container>
    }
    @if (last && isDragging) {
      <tr [attr.data-share]="item?.precondition?.id" (drop)="onDrop($event, index+1)"
          (dragover)="onDragOver($event)">
        <td colspan="100" class="tw-text-center">
          {{ 'lang.globals.positionAtEnd' | translate }} {{ item.name }}
        </td>
      </tr>
    }
  }

</ng-template>
